import React from 'react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="bg-white py-16 px-4 sm:px-6 lg:px-8 lg:py-24">
      <div className="max-w-3xl mx-auto">
        <div className="text-center">
          <h1 className="text-4xl font-extrabold tracking-tight text-gray-900">
            Politique de Confidentialité
          </h1>
          <p className="mt-2 text-lg text-gray-600">
            En vigueur au 11/07/2025
          </p>
        </div>

        <div className="mt-12 space-y-12 text-gray-700">
          <section>
            <h2 className="text-2xl font-semibold text-gray-900">Introduction</h2>
            <p className="mt-2">
              api100.io est un service proposé par Global Gestion Sàrl, basé en Suisse. Nous nous engageons à respecter la vie privée des utilisateurs et à traiter leurs données conformément à la LPD (nouvelle Loi fédérale sur la protection des données, Suisse) et au RGPD (UE).
            </p>
            <p>
              En utilisant notre site web et nos services, vous acceptez les pratiques décrites dans cette politique de confidentialité.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">Données collectées</h2>
            <ul className="list-disc list-inside mt-2">
              <li><strong>Données personnelles</strong> : adresse email (création de compte, support, facturation)</li>
              <li><strong>Données techniques</strong> : statistiques d’usage anonymes (nombre de requêtes, taille, bande passante)</li>
              <li><strong>Sécurité</strong> : adresse IP et logs de connexion pour détection d’abus ou usage frauduleux</li>
            </ul>
            <p className="mt-2 font-semibold text-red-600">
              Nous ne stockons ni n’inspectons le contenu des requêtes transitant par notre reverse proxy.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">Utilisation des données</h2>
            <ul className="list-disc list-inside mt-2">
              <li>Fournir l’accès au service api100.io</li>
              <li>Suivre l’usage technique (statistiques anonymes)</li>
              <li>Répondre aux demandes d’assistance</li>
              <li>Respecter nos obligations légales</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">Stockage et hébergement</h2>
            <p className="mt-2">
              Toutes les données sont hébergées en Suisse chez Infomaniak SA, dans un datacenter écologique alimenté à 100 % en énergie renouvelable. La chaleur est revalorisée pour chauffer le quartier.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">Sécurité</h2>
            <p className="mt-2">
              Nous appliquons des mesures techniques et organisationnelles strictes pour protéger vos données contre les accès non autorisés.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">Vos droits</h2>
            <ul className="list-disc list-inside mt-2">
              <li>Accès à vos données</li>
              <li>Rectification</li>
              <li>Suppression</li>
              <li>Opposition</li>
              <li>Limitation du traitement</li>
              <li>Portabilité</li>
            </ul>
            <p className="mt-2">
              Vous pouvez exercer ces droits en nous contactant à l’adresse ci-dessous.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">Contact</h2>
            <p className="mt-2">
              Global Gestion Sàrl<br />
              Route de Collex 22D, 1294 Genthod, Suisse<br />
              ✉️ <a href="mailto:privacy@api100.io" className="text-blue-600 hover:underline">privacy@api100.io</a><br />
              ☎️ +41 58 332 23 70
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">Mise à jour</h2>
            <p className="mt-2">
              Cette politique peut être mise à jour à tout moment. La version en vigueur est disponible sur api100.io.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
